import React, {FC, useEffect, useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import Select from 'react-select'
import {
  buildDropdownAudit,
  fetchData,
  getEncryptedRoute,
  hasSpecialCharacters,
  isSpecificSpecialCharacters,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import {AddTourPackageHeader} from './AddTourPackageHeader'
import {Tr} from '../../../_metronic/i18n/Tr'

const AddTourPackageBasicInfo: FC = () => {
  let t = Tr()
  const tmp = sessionStorage.getItem('admin')
  const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''
  const location = useLocation()
  const editTourpackageId = (location.state as any)?.tourpackageId || ''
  const {menuId} = useMenuIdPermissions()
const specialCharacterRegex = /^[a-zA-Z\u0400-\u04FF<>,-."'*()`’ ]*$/;


  const vendorId2 = (location.state as any)?.vendorId || ''

  if (vendorId2 != '' && vendorId2 != null) {
    sessionStorage.setItem('vendor', vendorId2)
    sessionStorage.setItem('selectedVendor', vendorId2)
  }
  const vendorId = sessionStorage.getItem('vendor')

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [tourPackageDetails, setTourPackageDetails] = useState([])
  const [tourAgencyNameEN, setTourAgencyNameEN] = useState('')
  const [tourAgencyNameRU, setTourAgencyNameRU] = useState('')
  const [tourAgencyNameUZ, setTourAgencyNameUZ] = useState('')
  const [contactPersonName, setContactPersonName] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [vendorList, setVendorList] = useState([])
  const [selectedVendor, setSelectedVendor] = useState(null)
  const [oldSelectedVendor, setOldSelectedVendor] = useState(null)
  const [oldPrimaryLanguageSelectedOptions, setOldPrimaryLanguageSelectedOptions] = useState<any>(null)

  // tour package list state start
  const [tourTypeList, setTourTypeList] = useState([])
  const [tourTypeSelectedOptions, setTourTypeSelectedOptions] = useState<any>([])
  const tourType = tourTypeSelectedOptions
    ? tourTypeSelectedOptions.map((option: any) => option.value).join(',')
    : ''
  // tour package list state end

  const [primaryLanguageList, setPrimaryLanguageList] = useState([
    {value: 'English', label: 'English'},
    {value: 'Russian', label: 'русский'},
    {value: 'Uzbek', label: 'O‘zbekcha'},
  ])
  const [primaryLanguageSelectedOptions, setPrimaryLanguageSelectedOptions] = useState<any>({
    value: 'English',
    label: 'English',
  })
  sessionStorage.setItem('primaryLanguage', primaryLanguageSelectedOptions.value)

  // service language list state end
  const changePrimaryLanguage = (val: any) => {
    setPrimaryLanguageSelectedOptions(val)
    removeError('primaryLanguage')
    sessionStorage.setItem('primaryLanguage', val.value)
  }

  const [socialMediaChannelList, setSocialMediaChannelList] = useState([
    {label: 'Instagram', value: 'Instagram'},
    {label: 'Facebook', value: 'Facebook'},
    {label: 'Linkedin', value: 'Linkedin'},
    {label: 'TikTok', value: 'TikTok'},
    {label: 'YouTube', value: 'YouTube'},
    {label: 'Website', value: 'Website'},
  ])

  const [socialMediaFields, setSocialMediaFields] = useState([
    {socialMediaType: '', socialMediaLink: ''},
  ])
  const [errors, setErrors] = useState([
    {
      socialMediaType: '',
      socialMediaLink: '',
    },
  ])

  const removeErrors = (index: any, fieldName: any) => {
    let newError = [...errors] as any
    if (!newError[index]) {
      newError[index] = {}
    }
    newError[index][fieldName] = '' // Clear error
    setErrors(newError)
  }
  const handleAddField = () => {
    setSocialMediaFields([...socialMediaFields, {socialMediaType: '', socialMediaLink: ''}])
  }

  const handleRemoveField = (index: any) => {
    const updatedFields = socialMediaFields.filter((_, i) => i !== index)
    setSocialMediaFields(updatedFields)
  }

  const handleChange = (index: any, field: any, value: any) => {
    const updatedFields = [...socialMediaFields] as any
    updatedFields[index][field] = value
    setSocialMediaFields(updatedFields)
    removeErrors(index, field) // Clear the error for the updated field
  }

  const getFilteredOptions = (currentIndex: any) => {
    const selectedValues = socialMediaFields.map((field, index) =>
      index !== currentIndex ? field.socialMediaType : ''
    )
    return socialMediaChannelList.filter((option) => !selectedValues.includes(option.value))
  }
  // set error state
  const [error, setError] = useState([
    {
      tourAgencyNameEN: '',
      tourAgencyNameRU: '',
      tourAgencyNameUZ: '',
      contactPersonName: '',
      email: '',
      phoneNumber: '',
      primaryLanguage: '',
      vendorId: '',
    },
  ])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  //   tour type List list api call
  const tourtypeListAPIcall = async () => {
    var res = await fetchData('vendor/public/tourtypeList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({value: val.tourtypeId, label: val.en_name})
      })
      setTourTypeList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  const getvendorlist = async () => {
    let param: any = {
      categoryId: '5',
    }

    var response: any = await fetchData('admin/vendorList', param)

    if (response.status == '200') {
      var data = response.data.map((item: any) => {
        return {value: item.vendorId, label: item.fullName}
      })
      setVendorList(data)
      var tmpven: any = sessionStorage.getItem('selectedVendor')
      var selvendor: any = data.filter((item: any) => item.value == tmpven)
      setSelectedVendor(selvendor.length > 0 ? selvendor[0] : null)
      setOldSelectedVendor(selvendor.length > 0 ? selvendor[0] : null)
      if (editTourpackageId != '') {
      }
    } else {
      toasterrormsg(response.message)
    }
  }

  const handleVendorChange = (e: any) => {
    setSelectedVendor(e)
    sessionStorage.setItem('vendor', e.value)
  }

  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguageSelectedOptions.value == 'English') {
      if (
        tourAgencyNameEN.trim() == '' ||
        tourAgencyNameEN.trim() == null ||
        tourAgencyNameEN.trim() == undefined
      ) {
        errorTmp[0].tourAgencyNameEN = t('Tour Agency Name Is Required')
        isValid = false
      } else if (!isSpecificSpecialCharacters(tourAgencyNameEN.trim() , specialCharacterRegex)) {
        errorTmp[0].tourAgencyNameEN = t("Only <>,.'*() ` ’ -type Of Special Character Are Allow.")
        isValid = false
      }
    } else if (primaryLanguageSelectedOptions.value == 'Russian') {
      if (
        tourAgencyNameRU.trim() == '' ||
        tourAgencyNameRU.trim() == null ||
        tourAgencyNameRU.trim() == undefined
      ) {
        errorTmp[0].tourAgencyNameRU = t('Tour Agency Name Is Required')
        isValid = false
      } else if (!isSpecificSpecialCharacters(tourAgencyNameRU.trim()  , specialCharacterRegex)) {
        errorTmp[0].tourAgencyNameRU = t("Only <>,.'*() ` ’ -type Of Special Character Are Allow.")
        isValid = false
      }
    } else if (primaryLanguageSelectedOptions.value == 'Uzbek') {
      if (
        tourAgencyNameUZ.trim() == '' ||
        tourAgencyNameUZ.trim() == null ||
        tourAgencyNameUZ.trim() == undefined
      ) {
        errorTmp[0].tourAgencyNameUZ = t('Tour Agency Name Is Required')
        isValid = false
      } else if (!isSpecificSpecialCharacters(tourAgencyNameUZ.trim() , specialCharacterRegex)) {
        errorTmp[0].tourAgencyNameUZ = t("Only <>,.'*() ` ’ -type Of Special Character Are Allow.")
        isValid = false
      }
    }
    if (
      contactPersonName.trim() == '' ||
      contactPersonName.trim() == null ||
      contactPersonName.trim() == undefined
    ) {
      errorTmp[0].contactPersonName = t('Person Name Is Required')
      isValid = false
    } else if (!isSpecificSpecialCharacters(contactPersonName.trim() , specialCharacterRegex)) {
      errorTmp[0].contactPersonName = t('Contact Person Name Is Not Valid')
      isValid = false
    }
    if (email == '' || email == undefined || email == null) {
      errorTmp[0].email = 'Email is required'
      isValid = false
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i.test(email)) {
      errorTmp[0].email = t('Email Is Not Valid.')
      isValid = false
    }
    if (phoneNumber == '' || phoneNumber == undefined || phoneNumber == null) {
      errorTmp[0].phoneNumber = t('Mobile Number Is Required')
      isValid = false
    } else if (!/^\d+$/.test(phoneNumber)) {
      errorTmp[0].phoneNumber = t('Only Numbers Are allowed.')
      isValid = false
    } else if (
      ((phoneNumber != '' && phoneNumber != undefined) || phoneNumber != null) &&
      phoneNumber.length < 8
    ) {
      errorTmp[0].phoneNumber = t('Minimum 8 Digit Required')
      isValid = false
    }
    let errorTmps = [...errors] as any

    socialMediaFields.forEach((field, index) => {
      if (!errorTmps[index]) {
        errorTmps[index] = {}
      }

      // Validate socialMediaType field
      if (!field.socialMediaType) {
        errorTmps[index].socialMediaType = t('Social Media Type Is Required')
        isValid = false
      } else {
        errorTmps[index].socialMediaType = '' // Clear error if socialMediaType is selected
      }

      // Validate socialMediaLink field
      if (!field.socialMediaLink || !field.socialMediaLink.trim()) {
        errorTmps[index].socialMediaLink = t('Social Media Link Is Required')
        isValid = false
      } else {
        errorTmps[index].socialMediaLink = '' // Clear error if socialMediaLink is provided
      }
    })

    setErrors(errorTmps)
    setError(errorTmp)
    return isValid
  }
  // add restaurant api call
  const addTourPackageApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      let param: any = {
        vendorId: String(vendorId),
        en_agencyName: tourAgencyNameEN,
        ru_agencyName: tourAgencyNameRU,
        uz_agencyName: tourAgencyNameUZ,
        primaryLanguage: primaryLanguageSelectedOptions.value,
        email: email,
        phoneNo: phoneNumber,
        contact_person_name: contactPersonName,
        socialMediaChannels: socialMediaFields,
        adminId: adminId,
        labels: buildDropdownAudit({
          vendor: {old: oldSelectedVendor, new: selectedVendor},
          primaryLanguage: {old: oldPrimaryLanguageSelectedOptions, new: primaryLanguageSelectedOptions},
        }),
      }

      var res = await fetchData('vendor/public/addTourPackage', param)
      if (res.status == '200') {
        toastsuccessmsg('Basic Information Saved Successfully!')
        var data = res.data[0]

        const state = {
          tourpackageId: data['tourpackageId'],
        }
        setTimeout(() => {
                    navigate(getEncryptedRoute('../addtourpackagelocation/', {menuId:menuId}), {state})

          setDisable(false)
          setLoading(false)
        }, 1500)
      } else {
        setLoading(false)
        setDisable(false)
        toasterrormsg(res.message)
      }
    }
  }
  // edit restaurant api call
  const editTourPackageApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      let param: any = {
        vendorId: String(vendorId),
        tourpackageId: String(editTourpackageId),
        en_agencyName: tourAgencyNameEN,
        ru_agencyName: tourAgencyNameRU,
        uz_agencyName: tourAgencyNameUZ,
        primaryLanguage: primaryLanguageSelectedOptions.value,
        email: email,
        phoneNo: phoneNumber,
        contact_person_name: contactPersonName,
        socialMediaChannels: socialMediaFields,
        adminId: adminId,
        labels: buildDropdownAudit({
          vendor: {old: oldSelectedVendor, new: selectedVendor},
          primaryLanguage: {old: oldPrimaryLanguageSelectedOptions, new: primaryLanguageSelectedOptions},
        }),
      }

      var res = await fetchData('vendor/public/addTourPackage', param)
      if (res.status == '200') {
        toastsuccessmsg('Basic Information Saved Successfully!')
        var data = res.data[0]

        const state = {
          tourpackageId: data['tourpackageId'],
        }
        setTimeout(() => {
          navigate(getEncryptedRoute('../addtourpackagelocation/', {menuId:menuId}), {state})

          setDisable(false)
          setLoading(false)
        }, 1500)
      } else {
        setDisable(false)
        toasterrormsg(res.message)
      }
    }
  }
  // space Details api call
  const tourPackageDetailsApiCall = async () => {
    var param: any = {
      tourpackageId: String(editTourpackageId),
    }
    var response: any = await fetchData('vendor/public/tourpackageDetails', param)

    if (response.status == '200') {
      setTourPackageDetails(response.data)
      var data = response.data[0]
      setPrimaryLanguageSelectedOptions({
        value: data.primaryLanguage,
        label: `${data.primaryLanguage}`,
      })
      setOldPrimaryLanguageSelectedOptions({
        value: data.primaryLanguage,
        label: `${data.primaryLanguage}`,
      })
      setTourAgencyNameEN(data.en_agencyName)
      setTourAgencyNameRU(data.ru_agencyName)
      setTourAgencyNameUZ(data.uz_agencyName)
      setContactPersonName(data.contact_person_name)
      setEmail(data.email)
      setPhoneNumber(data.phoneNo)
      setSocialMediaFields(data.socialMediaChannels)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    getvendorlist()
    tourtypeListAPIcall()
    if (editTourpackageId != '') {
      tourPackageDetailsApiCall()
    }
  }, [])
  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editTourpackageId != '' ? t('Edit Tour Package') : t('Add Tour Package')}
      </PageTitle>
      <AddTourPackageHeader tourpackageId={editTourpackageId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Tour Package Basic Information')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {tourPackageDetails.length != 0 ? (
                            <>
                              {tourPackageDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['toursDetail']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{width: `${percentage}%`}}
                                      ></div>
                                    </div>
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{width: '0%'}}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      <div className='card-body pt-10'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>{t('Select Vendor')}</label>

                            <Select
                              name='vendor'
                              id='vendorId'
                              isDisabled={editTourpackageId != ''}
                              placeholder={t('Select Vendor')}
                              isSearchable={true}
                              options={vendorList}
                              value={selectedVendor}
                              onChange={handleVendorChange}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].vendorId}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>
                              {t('Primary Language')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='primaryLanguage[]'
                              id='primaryLanguage'
                              placeholder={t('Select Primary Language')}
                              isSearchable={true}
                              options={primaryLanguageList}
                              value={primaryLanguageSelectedOptions}
                              onChange={(e: any) => {
                                changePrimaryLanguage(e)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].primaryLanguage}</div>
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      {/* <!--end::Card body--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-0'>
                        {primaryLanguageSelectedOptions.value == 'English' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Tour Agency Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='tourAgencyNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Tour Agency Name')}
                                  value={tourAgencyNameEN}
                                  onChange={(e) => {
                                    setTourAgencyNameEN(e.target.value)
                                    removeError('tourAgencyNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].tourAgencyNameEN}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Tour Agency Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='tourAgencyNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Tour Agency Name')}
                                  value={tourAgencyNameRU}
                                  onChange={(e) => {
                                    setTourAgencyNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Tour Agency Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='tourAgencyNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Tour Agency Name')}
                                  value={tourAgencyNameUZ}
                                  onChange={(e) => {
                                    setTourAgencyNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguageSelectedOptions.value == 'Russian' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Tour Agency Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='tourAgencyNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Tour Agency Name')}
                                  value={tourAgencyNameRU}
                                  onChange={(e) => {
                                    setTourAgencyNameRU(e.target.value)
                                  }}
                                />
                                <div className='text-danger fw-bold'>
                                  {error[0].tourAgencyNameRU}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Tour Agency Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='tourAgencyNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Tour Agency Name')}
                                  value={tourAgencyNameEN}
                                  onChange={(e) => {
                                    setTourAgencyNameEN(e.target.value)
                                    removeError('tourAgencyNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Tour Agency Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='tourAgencyNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Tour Agency Name')}
                                  value={tourAgencyNameUZ}
                                  onChange={(e) => {
                                    setTourAgencyNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguageSelectedOptions.value == 'Uzbek' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Tour Agency Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='tourAgencyNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Tour Agency Name')}
                                  value={tourAgencyNameUZ}
                                  onChange={(e) => {
                                    setTourAgencyNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].tourAgencyNameUZ}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Tour Agency Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='tourAgencyNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Tour Agency Name')}
                                  value={tourAgencyNameRU}
                                  onChange={(e) => {
                                    setTourAgencyNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Tour Agency Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='tourAgencyNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Tour Agency Name')}
                                  value={tourAgencyNameEN}
                                  onChange={(e) => {
                                    setTourAgencyNameEN(e.target.value)
                                    removeError('tourAgencyNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                      </div>
                      {/* <!--end::Card body--> */}
                      <div className='card-body pt-0'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>
                              {t('Contact Person Name')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='contactPersonName'
                              className='form-control mb-2'
                              placeholder={t('Contact Person Name')}
                              value={contactPersonName}
                              onChange={(e) => {
                                setContactPersonName(e.target.value)
                                removeError('contactPersonName')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].contactPersonName}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>{t('Email')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='email'
                              className='form-control mb-2'
                              placeholder={t('Email')}
                              value={email}
                              onChange={(e) => {
                                setEmail(e.target.value)
                                removeError('email')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].email}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>{t('Phone Number')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='phoneNumber'
                              className='form-control mb-2'
                              placeholder={t('Phone Number')}
                              value={phoneNumber}
                              onChange={(e) => {
                                setPhoneNumber(e.target.value)
                                removeError('phoneNumber')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].phoneNumber}</div>
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      <div className='card-body pt-0'>
                        <div className='row'>
                          <div className='col-lg-12'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>
                              {t('Social Media Channel')}
                            </label>
                            {/* <!--end::Label--> */}
                          </div>
                        </div>
                        {socialMediaFields.map((field, index) => (
                          <div className='row' key={index}>
                            <div className='col-lg-4 my-3'>
                              <Select
                                name='socialMediaChannels[]'
                                id={`socialMediaChannels-${index}`}
                                placeholder={t('Select Social Media Channels')}
                                isSearchable={true}
                                options={getFilteredOptions(index)}
                                value={socialMediaChannelList.find(
                                  (option) => option.value === field.socialMediaType
                                )}
                                onChange={(selectedOption: any) =>
                                  handleChange(index, 'socialMediaType', selectedOption.value)
                                }
                              />
                              {errors[index]?.socialMediaType && (
                                <div className='text-danger fw-bold'>
                                  {errors[index].socialMediaType}
                                </div>
                              )}
                            </div>
                            <div className='col-lg-4 my-3'>
                              <input
                                type='text'
                                className='form-control mb-2'
                                name='socialMediaLinks'
                                id={`socialMediaLinks-${index}`}
                                placeholder={t('Social Media Link')}
                                value={field.socialMediaLink}
                                onChange={(e) =>
                                  handleChange(index, 'socialMediaLink', e.target.value)
                                }
                              />
                              {errors[index]?.socialMediaLink && (
                                <div className='text-danger fw-bold'>
                                  {errors[index].socialMediaLink}
                                </div>
                              )}
                            </div>
                            <div className='col-lg-4 my-3'>
                              <button
                                className='btn btn-success mx-1'
                                type='button'
                                onClick={handleAddField}
                              >
                                +
                              </button>
                              {socialMediaFields.length > 1 && index != 0 && (
                                <button
                                  className='btn btn-danger mx-1'
                                  type='button'
                                  onClick={() => handleRemoveField(index)}
                                >
                                  -
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className='d-flex justify-content-end'>
                {/* <!--begin::Button--> */}
                <Link
                  to={getEncryptedRoute('../viewtourpackages/', {menuId:menuId})}
                  id='kt_ecommerce_add_product_cancel'
                  className='btn btn-light me-5'
                >
                  {t('Cancel')}
                </Link>

                <button
                  type='submit'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={() => {
                    if (editTourpackageId !== '') {
                      editTourPackageApi()
                    } else {
                      addTourPackageApi()
                    }
                  }}
                >
                  <span className='indicator-label'>{t('Next')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export {AddTourPackageBasicInfo}
